import VueCharts from "vue-chartjs";
import { Bar, Line } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["low", "mid", "high", "labels"],

  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            type: "bar",
            label: "เสี่ยงต่ำ",
            data: this.low,
            backgroundColor: "#48BB78",
          },
          {
            type: "bar",
            label: "เสี่ยงปานกลาง",
            backgroundColor: "#F6AD55",
            data: this.mid,
          },
          {
            type: "bar",
            label: "เสี่ยงสูง",
            backgroundColor: "#F56565",
            data: this.high,
          },
        ],
      },
      {
        title: {
          display: false,
          text: "",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: "คน",
              },
            },
          ],
          xAxes: [
            {
              stacked: false,
              ticks: {
                stepSize: 1,
                min: 0,
                autoSkip: false
              }
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    );
  },
};
